<template>
  <div>
    <el-button size="mini" class="icon_btn" @click="dialogVisible = true">
      <span v-if="!copyicon">请选择图标</span>
      <i class="icon" v-else :class="copyicon"></i>
    </el-button>
    <el-dialog title="选择图标" :visible.sync="dialogVisible" width="420px">
      <el-scrollbar style="height: 200px; min-height: 40px">
        <div
          class="icon-item"
           
          v-for="(item, index) in icons"
          :key="index"
          @click="active(item)"
          :class="{ 'active' : item == copyicon}"
        >
          <i :class="item"></i>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ICONS from "@/utils/icons.js";
export default {
  props: ["curricon"],
  data() {
    return {
      icons: ICONS,
      dialogVisible: false,
      copyicon: ""
    };
  },
  watch: {
    curricon: {
      handler(newValue, oldValue) {
        this.copyicon = this.curricon;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    active(icon) {
      if (this.curricon == icon) {
        return;
      }
      this.copyicon = icon;
      this.dialogVisible = false;
      this.$emit("activeIcon", this.copyicon);
    }
  },
  mounted() {
    this.copyicon = this.curricon;
  }
};
</script>
<style>
.icon-item {
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 1px solid #999;
  font-size: 20px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  margin-right: 10px;
}
.icon-item:hover,
.icon-item.active {
  border-color: #66b1ff;
  color: #66b1ff;
  cursor: pointer;
}
</style>